export enum reportActionTypes {
    GET_CARDS_INFO_BEGIN = "GET_CARDS_INFO_BEGIN",
    GET_CARDS_INFO_ERROR = "GET_CARDS_INFO_ERROR",
    GET_CARDS_INFO_SUCCESS = "GET_CARDS_INFO_SUCCESS",
    GET_TABLE_INFO_BEGIN = "GET_TABLE_INFO_BEGIN",
    GET_TABLE_INFO_ERROR = "GET_TABLE_INFO_ERROR",
    GET_TABLE_INFO_SUCCESS = "GET_TABLE_INFO_SUCCESS"
}